<template>
  <div class="plat-site-manager-distribute-site"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <div class="distribute-cont"
         v-loading="committing"
         element-loading-text="数据提交中，请稍等...">
      <el-transfer v-model="siteIds"
                   :data="sites"
                   filterable
                   :titles="['可选教学点', '已选教学点']"
                   :props="defaultProps">
      </el-transfer>
    </div>
    <div class="footer">
      <el-button size="mini"
                 type="primary"
                 :disabled="committing"
                 @click="handleApply">提交设置</el-button>
      <el-button size="mini"
                 type="default"
                 @click="handleClose">取消操作</el-button>
    </div>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
export default {
  name: 'PlatSiteManagerDistributeSite',
  components: {
    AppScrollbar
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      originSiteIds: [],
      sites: [],
      siteIds: [],
      defaultProps: {
        key: 'id',
        label: 'name'
      },
      committing: false
    }
  },
  methods: {
    loadDistributeInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/plat/management/peSiteManager/distributeSite',
        method: 'post',
        data: this.$qs.stringify({
          postId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              let distributeSite = response.data['distributeSite'] || {}
              this.originSiteIds = distributeSite['siteIds'] || []
              this.sites = distributeSite['sites'] || []
              this.siteIds = this.originSiteIds.concat()
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleApply () {
      let siteIds = this.siteIds || []
      let originSiteIds = this.originSiteIds || []
      let addSiteIds = []
      let delSiteIds = []
      siteIds.forEach(id => {
        if (!originSiteIds.includes(id)) {
          addSiteIds.push(id)
        }
      })
      originSiteIds.forEach(id => {
        if (!siteIds.includes(id)) {
          delSiteIds.push(id)
        }
      })
      if (addSiteIds.length === 0 && delSiteIds.length === 0) {
        this.$message.warning('配置未发生变化')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/plat/management/peSiteManager/submitDistributeSite',
        method: 'post',
        data: this.$qs.stringify({
          postId: this.rowData.id,
          addSiteIds: addSiteIds,
          delSiteIds: delSiteIds
        }, {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.$nextTick(() => {
                this.originSiteIds = siteIds.concat()
                this.$emit('hidePopover')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    this.loadDistributeInfo()
  }
}
</script>

<style lang="scss">
  .plat-site-manager-distribute-site {
    .distribute-cont {
      height: 100%;
      padding: 15px;
      box-sizing: border-box;
      .el-transfer {
        display: flex;
        align-items: center;
        font-size: 12px;
        & > .el-transfer-panel {
          flex: 0 1 50%;
          width: auto;
          border-radius: 0;
          .el-transfer-panel__header {
            .el-checkbox {
              .el-checkbox__label {
                font-size: 13px;
              }
            }
          }
          .el-transfer-panel__body {
            height: 360px;
            .el-transfer-panel__list {
              height: 420px;
              &.is-filterable {
                height: 373px;
              }
            }
            .el-checkbox {
              .el-checkbox__label {
                font-size: 12px;
              }
            }
          }
        }
        & > .el-transfer__buttons {
          padding-left: 10px;
          padding-right: 10px;
          white-space: nowrap;
          .el-button {
            padding: 4px;
          }
        }
      }
    }
    & > .footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
